import React, { useCallback } from 'react'

import styles from './style.module.scss'

import HelpSvg from '@svgs/help.svg'
import LogoutSvg from '@svgs/logout.svg'

import { useTranslation } from 'i18n'
import { SideBarButton } from 'components/SideBar'
import { useAuth } from 'v2/hooks/useAuth'
import XColors from 'v2/styles/colors'

interface Props {
    isLanguageSwitcher?: boolean
}

const XAuthMobileFooter = (props: Props) => {
    const { t } = useTranslation(window.LANG_NS)
    const { logoutUser } = useAuth()
    const onClickSignOut = useCallback((e: any) => {
        void logoutUser()
    }, [])
    return (
        <footer className={styles.footer}>
            <div>
                <SideBarButton
                    title={t('side_bar_button_help')}
                    icon={HelpSvg}
                    iconSize={18}
                    backgroundColor={'transparent'}
                    color={XColors.white2}
                    tintColor={XColors.white2}
                    width={'35px'}
                    textColor={XColors.white2}
                    fontWeight={'400'}
                    href={`${
                        window.PERSON?.applicationDetails[0].program?.urlFragment || window.PROGRAM.urlFragment
                    }/help`}
                />

                <SideBarButton
                    title={t('side_bar_button_sign_out')}
                    icon={LogoutSvg}
                    iconSize={18}
                    tintColor={XColors.white2}
                    backgroundColor={'transparent'}
                    fontWeight={'400'}
                    width={'35px'}
                    textColor={XColors.white2}
                    href="#"
                    onClick={onClickSignOut}
                    id="sign-out-button"
                />
            </div>
        </footer>
    )
}

XAuthMobileFooter.displayName = 'LoggedInFooter'

export default XAuthMobileFooter
